import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { AuthService } from '../services/auth.service';
import { SharedService } from '../services/shared.service';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const configService = inject(ConfigService);
  const authService = inject(AuthService);
  const sharedService = inject(SharedService);

  const suppliedToken =
    req.headers.get('token') || req.headers.get('JwtToken') || '';
  const suppliedCompanyCode = req.headers.get('companycode') || '';
  const promptAdminPassword = req.headers.get('X-Prompt-Admin-Password') || '';
  let headers = req.headers
    .delete('Authorization')
    .delete('ApiSecret')
    .delete('Service-Secret')
    .delete('X-Service-Secret')
    .delete('X-Prompt-Admin-Password')
    .delete('JwtToken');

  const bffBaseUrl = configService.getApiUrl('bffBaseUrl');
  const isBffRequest = req.url.startsWith(bffBaseUrl);
  const isPublicBffRequest = req.url.startsWith(`${bffBaseUrl}public/`);

  if (isBffRequest && !isPublicBffRequest) {
    const token = suppliedToken || authService.getToken();
    const companyCode =
      suppliedCompanyCode ||
      sharedService.getCookie('companycode') ||
      sharedService.getCookie('clientCode') ||
      '';

    if (token) {
      headers = headers.set('token', token);
    }
    if (companyCode) {
      headers = headers.set('companycode', companyCode);
    }
    if (
      promptAdminPassword &&
      req.url.startsWith(`${bffBaseUrl}jpage/ai/prompt`)
    ) {
      headers = headers.set('X-Prompt-Admin-Password', promptAdminPassword);
    }
  } else {
    headers = headers.delete('token').delete('companycode');
  }

  return next(req.clone({ headers }));
};
